import Vue from 'vue';

const mixin = Vue.mixin({
  data() {
    return {
      errorList: [
        // Generic
        { errorCode: 1847493, stringKey: 'ERROR_UNAUTHORIZED' }, // Unauthorized
        { errorCode: 1847494, stringKey: 'ERROR_ADMIN_ONLY' }, // Action restricted to administrators
        { errorCode: 1847495, stringKey: 'ERROR_BACKEND_UNAVAILABLE' }, // The multimedia backend is currently unavailable

        // Parameters
        { errorCode: 1847496, stringKey: 'ERROR_PARAMETER_INVALID' }, // Invalid parameter given
        { errorCode: 1847497, stringKey: 'ERROR_PARAMETER_MISSING' }, // A required parameter is missing

        // Auth
        { errorCode: 1847498, stringKey: 'ERROR_AUTH_ALREADY_AUTHENTICATED' }, // Already authenticated
        { errorCode: 1847499, stringKey: 'ERROR_AUTH_INVALID_CREDENTIALS' }, // Incorrect username or password
        { errorCode: 1847500, stringKey: 'ERROR_AUTH_NO_CHANNEL' }, // No channel assigned to user

        // Instance
        { errorCode: 1847501, stringKey: 'ERROR_INSTANCE_OWNED_BY_OTHER' }, // Instance locked by another user
        { errorCode: 1847502, stringKey: 'ERROR_INSTANCE_NOT_USED' }, // No instance owned
        { errorCode: 1847503, stringKey: 'ERROR_INSTANCE_INEXISTENT' }, // Instance does not exist
        { errorCode: 1847504, stringKey: 'ERROR_INSTANCE_ALREADY_LOCKED' }, // Another instance is already locked
        { errorCode: 1847505, stringKey: 'ERROR_INSTANCE_UNLOCK_FIRST' }, // The current instance must first be unlocked
        { errorCode: 1847506, stringKey: 'ERROR_INSTANCE_NOT_LIVE' }, // Instance must be in live mode
        { errorCode: 1847507, stringKey: 'ERROR_INSTANCE_READONLY' }, // The session is currently in read-only mode

        // Channel
        { errorCode: 1847508, stringKey: 'ERROR_CHANNEL_INVALID' }, // Channel does not exist
        { errorCode: 1847509, stringKey: 'ERROR_CHANNEL_LIST_EMPTY' }, // No channel available
        { errorCode: 1847510, stringKey: 'ERROR_CHANNEL_NO_PERMISSION' }, // You do not have access this channel
        { errorCode: 1847511, stringKey: 'ERROR_CHANNEL_SHARED' }, // The channel is shared
        { errorCode: 1847512, stringKey: 'ERROR_CHANNEL_INACCESSIBLE' }, // The target channel is inaccessible
        { errorCode: 1847513, stringKey: 'ERROR_CHANNEL_MUST_BE_SHARED' }, // The current channel must be shared

        // Media
        { errorCode: 1847514, stringKey: 'ERROR_MEDIA_NOT_FOUND' }, // No matching media was found
        { errorCode: 1847515, stringKey: 'ERROR_MEDIA_NOT_ASSIGNED' }, // No media assigned to this instance
        { errorCode: 1847516, stringKey: 'ERROR_MEDIA_LIST_UNAVAILABLE' }, // The media list is unavailable
        { errorCode: 1847517, stringKey: 'ERROR_CATEGORY_LIST_UNAVAILABLE' }, // The category list is unavailable

        // History
        { errorCode: 1847518, stringKey: 'ERROR_HISTORY_EMPTY' }, // The history is empty

        // Channel settings
        { errorCode: 1847519, stringKey: 'ERROR_SETTINGS_LIST' }, // cannot be a list
        { errorCode: 1847520, stringKey: 'ERROR_SETTINGS_DICT' }, // cannot be a dict
        { errorCode: 1847521, stringKey: 'ERROR_SETTINGS_STRING' }, // cannot be a string
        { errorCode: 1847522, stringKey: 'ERROR_SETTINGS_BOOL' }, // cannot be a boolean
        { errorCode: 1847523, stringKey: 'ERROR_SETTINGS_INT' }, // cannot be an integer
        { errorCode: 1847524, stringKey: 'ERROR_SETTINGS_INVALID_KEY' }, // cannot contain key
        { errorCode: 1847525, stringKey: 'ERROR_SETTINGS_INVALID_FORMAT' }, // does not match the required format

        // Live mode
        { errorCode: 1847526, stringKey: 'ERROR_LIVE_ONGOING_CHANNEL' }, // A live session is on-going in this channel
        { errorCode: 1847527, stringKey: 'ERROR_LIVE_ONGOING_INSTANCE' }, // A live session is on-going in this instance
        { errorCode: 1847528, stringKey: 'ERROR_LIVE_RECORDING' }, // The live session is currently recording
        { errorCode: 1847529, stringKey: 'ERROR_LIVE_INVALID_INSTANCE' }, // This instance does not match the channel's live mode session
        { errorCode: 1847530, stringKey: 'ERROR_LIVE_ALREADY_PAUSED' }, // The live session is already paused
        { errorCode: 1847531, stringKey: 'ERROR_LIVE_NO_CURRENT_CHAPTER' }, // There is no current chapter
        { errorCode: 1847532, stringKey: 'ERROR_LIVE_NO_STREAM' }, // Livestreams must be configured in order to use live mode
        { errorCode: 1847533, stringKey: 'ERROR_DEVICE_STREAM_START' }, // One of the streaming devices could not be started
        { errorCode: 1847534, stringKey: 'ERROR_DEVICE_STREAM_STOP' }, // One of the streaming devices could not be stopped
        { errorCode: 1847535, stringKey: 'ERROR_DEVICE_PRESET_FAILED' }, // Setting preset to video device failed

        // Import script
        { errorCode: 1847532, stringKey: 'ERROR_SCRIPT_NOT_PRESENT' }, // The data import script is not present
        { errorCode: 1847533, stringKey: 'ERROR_SCRIPT_FAILED' }, // The data import script did not complete successfully
      ],
    };
  },
  methods: {
    getKeyByErrorCode(errorCode) {
      return this.errorList.find(error => error.errorCode === errorCode).stringKey;
    },
    getErrorCodeByKey(key) {
      return this.errorList.find(error => error.stringKey === key).errorCode;
    },
  },
});

export default mixin;
